import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { GUARANTEED } from '../logic/common/state'
type Refresh = () => void

interface CloneItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingCloneItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmClone: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenCloneModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const cloneItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingCloneItem,
  setNameReserve,
  setHashItemReserve,
  setConfirmClone,
  setOpenCloneModal,
}: CloneItemReservationParams): Promise<void> => {
  try {
    setLoadingCloneItem(true)
    setOpenCloneModal && setOpenCloneModal(false)
    let status = null
    status = await itemServices.clone_item(hashItemReserve)
    
    if (status == 200) {
      notify('ra.notification.clone_item_success', {
        type: 'success',
        messageArgs: { item: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmClone && setConfirmClone(false)
      setLoadingCloneItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmClone && setConfirmClone(false)
    setLoadingCloneItem(false)
    notify('ra.notification.clone_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.clone_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingCloneItem(false)
    setConfirmClone && setConfirmClone(false)
    setOpenCloneModal && setOpenCloneModal(false)
  } finally {
    customAwait([refresh])
  }
}
